export default "__VITE_ASSET__tw28PKPc__";